export enum StepsDirection {
  Vertical = 'vertical',
  Horizontal = 'horizontal'
}